/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type studioDashboardComponent_viewer$ref = any;
export type studioDashboardComponent_QueryVariables = {|
  shareKey?: ?string,
  componentId?: ?string,
  dateCriteria?: ?string,
|};
export type studioDashboardComponent_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: studioDashboardComponent_viewer$ref,
  |}
|};
export type studioDashboardComponent_Query = {|
  variables: studioDashboardComponent_QueryVariables,
  response: studioDashboardComponent_QueryResponse,
|};
*/


/*
query studioDashboardComponent_Query(
  $shareKey: String
  $componentId: ID
  $dateCriteria: String
) {
  viewer {
    actualPersonId
    component(name: "studio_dashboard")
    ...studioDashboardComponent_viewer_4j1l1
    id
  }
}

fragment studioDashboardComponent_viewer_4j1l1 on Viewer {
  insightComponentsData(shareKey: $shareKey) {
    studioDashboard(componentId: $componentId, dateCriteria: $dateCriteria) {
      id
      currency
      minutesAllRemaining
      minutesAllForecast
      minutesAllTimeRegs
      minutesBillableRemaining
      minutesBillableForecast
      minutesBillableTimeRegs
      minutesNonBillableRemaining
      minutesNonBillableForecast
      minutesNonBillableTimeRegs
      costAllRemaining
      costAllForecast
      costAllTimeRegs
      costBillableRemaining
      costBillableForecast
      costBillableTimeRegs
      costNonBillableRemaining
      costNonBillableForecast
      costNonBillableTimeRegs
      priceAllRemaining
      priceAllForecast
      priceAllTimeRegs
      priceBillableRemaining
      priceBillableForecast
      priceBillableTimeRegs
      priceNonBillableRemaining
      priceNonBillableForecast
      priceNonBillableTimeRegs
      expensesCost
      expensesPrice
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shareKey",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "componentId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dateCriteria",
    "type": "String"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "studio_dashboard"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"studio_dashboard\")"
},
v3 = {
  "kind": "Variable",
  "name": "componentId",
  "variableName": "componentId"
},
v4 = {
  "kind": "Variable",
  "name": "dateCriteria",
  "variableName": "dateCriteria"
},
v5 = {
  "kind": "Variable",
  "name": "shareKey",
  "variableName": "shareKey"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "studioDashboardComponent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "studioDashboardComponent_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "studioDashboardComponent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": [
              (v5/*: any*/)
            ],
            "concreteType": "InsightComponentsDataType",
            "kind": "LinkedField",
            "name": "insightComponentsData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "concreteType": "StudioDashboard",
                "kind": "LinkedField",
                "name": "studioDashboard",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minutesAllRemaining",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minutesAllForecast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minutesAllTimeRegs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minutesBillableRemaining",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minutesBillableForecast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minutesBillableTimeRegs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minutesNonBillableRemaining",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minutesNonBillableForecast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minutesNonBillableTimeRegs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costAllRemaining",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costAllForecast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costAllTimeRegs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costBillableRemaining",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costBillableForecast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costBillableTimeRegs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costNonBillableRemaining",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costNonBillableForecast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costNonBillableTimeRegs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceAllRemaining",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceAllForecast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceAllTimeRegs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceBillableRemaining",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceBillableForecast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceBillableTimeRegs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceNonBillableRemaining",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceNonBillableForecast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceNonBillableTimeRegs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expensesCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expensesPrice",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "studioDashboardComponent_Query",
    "operationKind": "query",
    "text": "query studioDashboardComponent_Query(\n  $shareKey: String\n  $componentId: ID\n  $dateCriteria: String\n) {\n  viewer {\n    actualPersonId\n    component(name: \"studio_dashboard\")\n    ...studioDashboardComponent_viewer_4j1l1\n    id\n  }\n}\n\nfragment studioDashboardComponent_viewer_4j1l1 on Viewer {\n  insightComponentsData(shareKey: $shareKey) {\n    studioDashboard(componentId: $componentId, dateCriteria: $dateCriteria) {\n      id\n      currency\n      minutesAllRemaining\n      minutesAllForecast\n      minutesAllTimeRegs\n      minutesBillableRemaining\n      minutesBillableForecast\n      minutesBillableTimeRegs\n      minutesNonBillableRemaining\n      minutesNonBillableForecast\n      minutesNonBillableTimeRegs\n      costAllRemaining\n      costAllForecast\n      costAllTimeRegs\n      costBillableRemaining\n      costBillableForecast\n      costBillableTimeRegs\n      costNonBillableRemaining\n      costNonBillableForecast\n      costNonBillableTimeRegs\n      priceAllRemaining\n      priceAllForecast\n      priceAllTimeRegs\n      priceBillableRemaining\n      priceBillableForecast\n      priceBillableTimeRegs\n      priceNonBillableRemaining\n      priceNonBillableForecast\n      priceNonBillableTimeRegs\n      expensesCost\n      expensesPrice\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4058cf7eb8677ffb5d0490be14aae854';

module.exports = node;
